import React from "react";
import img1 from "../../Assets/2nd_slider/6290-is.png";
import img2 from "../../Assets/2nd_slider/6288-hc 1.png";
import img3 from "../../Assets/2nd_slider/5569-oi.png"
import Third_slider from "./Third_slider";

const banners = [
  {
    id: 1,
    img: img1, // left
  },
  {
    id: 2,
    img: img2, // center (big)
  },
  {
    id: 3,
    img: img3, // right
  },
];

const Secound_slider = () => {
  return (
    <> 
    <div className="w-full bg-white py-8">
      {/* Slider */}
      <div
        className="
          max-w-7xl mx-auto
          flex gap-6
          overflow-x-auto
          lg:overflow-visible
          scrollbar-hide
          px-4
        "
      >
        {banners.map((item, index) => (
          <div
            key={item.id}
            className={`
              flex-shrink-0
              rounded-2xl
              overflow-hidden
              bg-gray-100
              transition-all

              ${
                index === 1
                  ? "w-[320px] sm:w-[420px] md:w-[520px] h-[180px] md:h-[220px]"
                  : "w-[260px] sm:w-[300px] md:w-[340px] h-[180px] md:h-[220px]"
              }
            `}
          >
            <img
              src={item.img}
              alt="banner"
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-5">
        <span className="w-2 h-2 rounded-full bg-gray-300"></span>
        <span className="w-5 h-2 rounded-full bg-teal-700"></span>
        <span className="w-2 h-2 rounded-full bg-gray-300"></span>
      </div>
    </div>
     {/* <Third_slider /> */}
        </>
  );
};

export default Secound_slider;
